import { type ComponentLayer, type CustomFeature, FeatureType } from '@types';
import { Collapse } from '@components/Collapse';
import { Dropdown, type DropdownItem } from '@components/Dropdown';
import { $editingComponentLayerApi } from '@stores/editingComponentLayerStores';
import { customButtonDefault } from '@modules/edit';
import { type CFSetData, CustomFeatureProvider } from '../CustomFeatureContext';
import FeatureSwitch from '../components/FeatureSwitch';
import AdvSceneSetting from '../customFeatureComponents/AdvSceneSetting';
import AdvNextSceneSetting from '../customFeatureComponents/AdvNextSceneSetting';

interface Props {
  data: ComponentLayer;
}

const items: DropdownItem<FeatureType>[] = [
  { id: FeatureType.noFunc, name: '无功能' },
  { id: FeatureType.scene, name: '场景切换' },
  { id: FeatureType.prevScene, name: '上一场景' },
  { id: FeatureType.nextScene, name: '下一场景' },
  { id: FeatureType.link, name: '超链接' },
  { id: FeatureType.mobile, name: '电话' },
  { id: FeatureType.map, name: '导航' },
  { id: FeatureType.media, name: '图文' },
  { id: FeatureType.text, name: '文本' },
  { id: FeatureType.article, name: '文章' },
  { id: FeatureType.doc, name: 'PDF' },
  { id: FeatureType.audio, name: '音频' },
  { id: FeatureType.video, name: '视频' },
  { id: FeatureType.miniProgram, name: '小程序' },
  { id: FeatureType.model3d, name: '3D模型' },
  { id: FeatureType.seqFrame, name: '逐帧环物' },
  { id: FeatureType.event, name: '事件' },
];

export function LayerActionSettings({ data }: Props) {
  const feat = data.data;
  const setFeat: CFSetData<CustomFeature> = (cb) => {
    $editingComponentLayerApi.update((draft) => {
      cb(draft.data);
    });
  };

  const handleFeatChange = (code: FeatureType) => {
    $editingComponentLayerApi.update((draft) => {
      draft.data = customButtonDefault(code);
    });
  };

  return (
    <CustomFeatureProvider setData={setFeat} data={feat}>
      <Collapse title="功能类型">
        <Dropdown
          items={items}
          selected={feat.code}
          onChange={handleFeatChange}
        />
      </Collapse>
      <FeatureSwitch code={feat.code} />
      {feat.code === FeatureType.scene && <AdvSceneSetting />}
      {feat.code === FeatureType.prevScene && <AdvNextSceneSetting reverse />}
      {feat.code === FeatureType.nextScene && <AdvNextSceneSetting />}
    </CustomFeatureProvider>
  );
}

export default LayerActionSettings;
